import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';

export class Standortgruppe {
  constructor({
    id,
    istRotationsplanAktiviert,
    standorte,
  }: {
    id: string;
    istRotationsplanAktiviert: boolean;
    standorte: Standort[];
  }) {
    this.id = id;
    this.istRotationsplanAktiviert = istRotationsplanAktiviert;
    this.standorte = standorte;
  }

  id: string;
  istRotationsplanAktiviert: boolean;
  standorte: Standort[];
}
